import {Injectable} from '@angular/core';

export enum LogLevel {
  TRACE = 0,
  DEBUG = 1,
  INFO = 2,
  WARNING = 3,
  ERROR = 4,
  CRITICAL = 5,
  NONE = 6
}

@Injectable({providedIn: 'root'})
export class LoggerService {

  private minimumLogLevel: LogLevel;

  public constructor() {
    this.minimumLogLevel = LogLevel.TRACE;
  }

  public log(logLevel: LogLevel, message: string, ...objects: any) {

    const logMessage = `[${new Date().toISOString()}] ${LogLevel[logLevel]}: ${message}`;

    if (logLevel < this.minimumLogLevel) {
      return;
    }

    switch (logLevel) {
      case LogLevel.TRACE:
      case LogLevel.DEBUG:
      case LogLevel.INFO:
        if (objects.length > 0) {
          console.log(logMessage, ...objects);
        } else {
          console.log(logMessage);
        }
        break;

      case LogLevel.WARNING:
        if (objects.length > 0) {
          console.warn(logMessage, ...objects);
        } else {
          console.warn(logMessage);
        }
        break;

      case LogLevel.ERROR:
      case LogLevel.CRITICAL:
        if (objects.length > 0) {
          console.error(logMessage, ...objects);
        } else {
          console.error(logMessage);
        }
        break;
    }
  }

  public setMinimumLogLevel(level: LogLevel): void {
    this.minimumLogLevel = level;
  }
}
